import { useState } from 'react';
import { Button, Card, CardBody, Col, Row } from 'reactstrap';
import { useToast } from '../../../../components/toast/ToastProvider';

interface Props {
  property_id: string;
  landlord_name: string;
  landlord_email?: string;
  landlord_id: string;
  is_validated_by_proper?: boolean;
  validated_by_proper_event: (
    propertyId: string,
    isVerified?: boolean,
  ) => Promise<void>;
}

const LandlordVerifiedCard = (props: Props) => {
  const {
    property_id,
    landlord_name,
    landlord_email,
    landlord_id,
    is_validated_by_proper = false,
    validated_by_proper_event,
  } = props;
  // El padre actualiza la prop solo si el API responde 200.
  const isVerified = is_validated_by_proper;
  const [isSaving, setIsSaving] = useState(false);
  const toast = useToast();

  const copyEmail = async () => {
    try {
      await navigator.clipboard.writeText(landlord_email ?? '');
      toast.success('Correo copiado.');
    } catch {
      toast.error('No se pudo copiar el correo.');
    }
  };

  const toggleVerified = async () => {
    setIsSaving(true);
    try {
      await validated_by_proper_event(property_id, !isVerified);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <Card>
      <CardBody>
        <Row className="align-items-center pb-3 mb-3 border-bottom">
          <div className="col">
            <p className="text-sm text-dark font-weight-bold mb-0">
              {isVerified && (
                <i className="fa-solid fa-circle-check text-success mr-2" />
              )}
              Propiedad verificada
            </p>
          </div>
          <Col className="col-auto">
            <label className="custom-toggle mb-0">
              <input
                type="checkbox"
                checked={isVerified}
                disabled={isSaving}
                onChange={toggleVerified}
              />
              <span
                className="custom-toggle-slider rounded-circle"
                data-label-off="No"
                data-label-on="Si"
              />
            </label>
          </Col>
        </Row>
        <p className="text-sm mb-1" style={{ color: '#525f7f' }}>
          Propietario
        </p>
        <div className="d-flex align-items-start justify-content-between">
          <div>
            <h4 className="mb-0">
              <a href={`/landlord/${landlord_id}/profile`}>{landlord_name}</a>
            </h4>
            {landlord_email && (
              <small style={{ color: '#525f7f' }}>
                <i className="fa-solid fa-envelope mr-1" />
                {landlord_email}
              </small>
            )}
          </div>
          <div className="text-nowrap">
            {landlord_email && (
              <>
                <Button
                  type="button"
                  size="sm"
                  color="secondary"
                  outline
                  className="btn-icon-only"
                  title="Copiar correo"
                  aria-label="Copiar correo"
                  onClick={copyEmail}
                >
                  <i className="fa-regular fa-copy" />
                </Button>
                <a
                  className="btn btn-sm btn-outline-secondary btn-icon-only ml-1"
                  title="Enviar correo"
                  aria-label="Enviar correo"
                  href={`mailto:${landlord_email}`}
                >
                  <i className="fa-solid fa-paper-plane" />
                </a>
              </>
            )}
            <a
              className="btn btn-sm btn-outline-primary btn-icon-only ml-1"
              title="Ver perfil del propietario"
              aria-label="Ver perfil del propietario"
              href={`/landlord/${landlord_id}/profile`}
            >
              <i className="fa-solid fa-user" />
            </a>
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

export default LandlordVerifiedCard;
